var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayedColors.length > 1
    ? _c(
        "div",
        {
          class: [
            _vm.bemBlock,
            "base-color-swatches",
            {
              "visually-hidden": _vm.visuallyHidden
            }
          ]
        },
        [
          _c(
            "ul",
            { class: _vm.bemElement("color-container") },
            _vm._l(_vm.displayedColors, function(color, index) {
              return _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: color.displayed,
                      expression: "color.displayed"
                    }
                  ],
                  key: index,
                  class: _vm.bemElement("item"),
                  attrs: { "data-attr": "color" }
                },
                [
                  _c(
                    "button",
                    {
                      class: [
                        _vm.bemElement("swatch", {
                          selected: _vm.isColorSelected(color)
                        })
                      ],
                      attrs: { type: "button", "data-color-code": color.code },
                      on: {
                        click: function($event) {
                          return _vm.handleSelectColor(color, $event)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "visually-hidden" }, [
                        _vm._v(_vm._s(color.text))
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        class: _vm.bemElement("swatch-display"),
                        style: {
                          "background-color": color.code ? color.code : ""
                        }
                      })
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.overflowMaxColors
            ? _c("button", {
                class: [
                  _vm.bemElement(_vm.expanded ? "shrink" : "expand"),
                  _vm.expanded ? "btn-minus" : "btn-plus"
                ],
                on: { click: _vm.toggleExtended }
              })
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }